const useView = () => {
    return localStorage.getItem('view') || '';
}

export default useView;